import Header from '../Header/Header.js';
import { Routes, Route, useLocation } from 'react-router-dom';
import Showticker from '../Ticker/Showticker.js';
import Economic from '../Economic/Economic.js';
import Watchlist from '../Watchlist/Watchlist.js';
import TechAn from '../TechnicalAnalysis/TechAn.js';
import Compare from '../Compare/Compare.js';
import Workbench from '../Workbench/Workbench.js';
import Backtesting from '../TechnicalAnalysis/Backtesting.js';

function InnerRoutes() {
  const location = useLocation();
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/discover" element={<Showticker />} />
        <Route path="/economicanalysis" element={<Economic />} />
        <Route path="/workbench" element={<Workbench />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/technicalanalysis" element={<Backtesting />} />
      </Routes>
    </div>
  );
}

export default InnerRoutes;
